export default __webpack_public_path__ + "static/media/da_ngon_ngu_vn.f1fd7a15.png";